<template>
	<div class="card">
		<div class="card-header">
			Izin Presensi
			<el-tooltip placement="right" content="Lihat data izin presensi">
				<el-button link type="primary" tag="router-link" to="izin">
					<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
				</el-button>
			</el-tooltip>
		</div>
		<div class="card-body row align-items-center" v-loading="loading">
			<span class="col-auto mx-auto" v-if="loading">Memuat...</span>
			<span class="col-auto mx-auto" v-else-if="!izinCounts.length">Data tidak ditemukan</span>
			<el-descriptions :column="1" border v-else>
				<el-descriptions-item v-for="ic in izinCounts" :key="`${ic.tahun}_${ic.bulan}`" :label="ic.bulan_tahun" label-align="right">
					<div class="hstack gap-1">
						<transition name="slide-up" mode="out-in">
							<span class="fs-5" :key="ic.jumlah">{{ ic.jumlah }}</span>
						</transition>
						<span>data izin</span>
					</div>
				</el-descriptions-item>
			</el-descriptions>
		</div>
	</div>
</template>

<script>
export default {
	name: "IzinPresensi",
	data() {
		return {
			izinCounts: [],
			loading: true,
		};
	},
	mounted() {
		this.$ws.main.on("izin:inserted", this.insertedIzin);
		this.$ws.main.on("izin:updated", this.updatedIzin);
		this.$ws.main.on("izin:deleted", this.deletedIzin);
		this.getJumlahIzinPresensi();
	},
	beforeUnmount() {
		this.$ws.main.off("izin:inserted");
		this.$ws.main.off("izin:updated");
		this.$ws.main.off("izin:deleted");
	},
	methods: {
		toWIB(dateStr) {
			const d = new Date(dateStr);
			return new Date(d.getTime() + 7 * 60 * 60 * 1000);
		},
		insertedIzin(data) {
			const d = JSON.parse(data);
			const tgl = this.toWIB(d.tanggal);
			const tahun = tgl.getFullYear();
			const bulan = tgl.getMonth() + 1;

			const idx = this.izinCounts.findIndex((lp) => lp.tahun === tahun && lp.bulan === bulan);

			if (idx !== -1) {
				this.izinCounts[idx] = {
					...this.izinCounts[idx],
					jumlah: this.izinCounts[idx].jumlah + 1,
				};
				return;
			}

			this.izinCounts.push({
				tahun,
				bulan,
				jumlah: 1,
				bulan_tahun: new Date(tgl).toLocaleDateString("id-ID", { month: "long", year: "numeric" }),
			});
		},
		updatedIzin(data) {
			const d = JSON.parse(data);
			if (!d.tanggal) return;

			const old_data = d.old_data;
			const old_tgl = this.toWIB(old_data.tanggal);
			const new_tgl = this.toWIB(d.tanggal);

			if (old_tgl.getMonth() === new_tgl.getMonth() && old_tgl.getFullYear() === new_tgl.getFullYear()) return;

			const old_tahun = old_tgl.getFullYear();
			const old_bulan = old_tgl.getMonth() + 1;
			const new_tahun = new_tgl.getFullYear();
			const new_bulan = new_tgl.getMonth() + 1;

			const oldIdx = this.izinCounts.findIndex((lp) => lp.tahun === old_tahun && lp.bulan === old_bulan);
			const newIdx = this.izinCounts.findIndex((lp) => lp.tahun === new_tahun && lp.bulan === new_bulan);

			if (oldIdx !== -1) {
				this.izinCounts[oldIdx] = {
					...this.izinCounts[oldIdx],
					jumlah: this.izinCounts[oldIdx].jumlah + 1,
				};
			}
			if (newIdx !== -1) {
				this.izinCounts[newIdx] = {
					...this.izinCounts[newIdx],
					jumlah: this.izinCounts[newIdx].jumlah + 1,
				};
			} else {
				this.izinCounts.push({
					tahun: new_tahun,
					bulan: new_bulan,
					jumlah: 1,
					bulan_tahun: new Date(new_tgl).toLocaleDateString("id-ID", { month: "long", year: "numeric" }),
				});
				this.izinCounts.sort((a, b) => {
					return b.tahun - a.tahun || b.bulan - a.bulan;
				});
			}
		},
		deletedIzin(data) {
			const d = JSON.parse(data);
			const tgl = this.toWIB(d.tanggal);
			const tahun = tgl.getFullYear();
			const bulan = tgl.getMonth() + 1;

			const idx = this.izinCounts.findIndex((lp) => lp.tahun === tahun && lp.bulan === bulan);

			if (idx !== -1) {
				this.izinCounts[idx] = {
					...this.izinCounts[idx],
					jumlah: this.izinCounts[idx].jumlah - 1,
				};
				return;
			}
		},
		async getJumlahIzinPresensi() {
			try {
				const { data } = await this.$defaultApi.post("/izin/count/month");

				const izin = data.izin_counts.map((i) => ({
					...i,
					bulan_tahun: new Date(i.tahun, i.bulan - 1, 1).toLocaleDateString("id-ID", { month: "long", year: "numeric" }),
				}));

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.izinCounts = izin;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style scoped></style>
